import React from 'react';
export default function Header() {
  return (
      <header className="header flex-center">
        <h1 className="flex-center"><img src="/assets/images/tit-CF.svg" height="32" alt="LOTTE C&amp;F"/> <span className="cf-none-mob">Cổng Thanh Toán LOTTE C&amp;F</span>
        </h1>
      </header>
  );
};